export function convertOrgOptionsToRole(orgAdmin, orgTeamsManagement) {
    if (orgAdmin) {
        return 'ORG_ADMIN';
    }
    if (orgTeamsManagement) {
        return 'ORG_TEAMS_MANAGEMENT';
    }
    return 'ORG_USER';
}
